<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import ActivityComponent from './ActivityComponent.vue'

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const { user, newAssignee, oldAssignee } = this.activity

      const creator = user.uuid === this.self.uuid ? this.$t('You') : user.name
      const action = !newAssignee ? 'unassigned' : oldAssignee ? 'reassigned' : 'assigned'
      let assignee = null

      if (newAssignee) {
        assignee = newAssignee.uuid === this.self.uuid ? user.uuid === this.self.uuid ? this.$t('yourself') : this.$t('you') : newAssignee.name
      }

      return `${creator} ${action} this task ${newAssignee ? `to <strong>${assignee}</strong>` : ''}.`
    },
  },
}
</script>
